teardown =
	teardown: ->

limitPips = 50
checkDivider = (value, divider) ->
	limit = if value > 1000 then 15 else limitPips
	pipsCount = value / divider

	value % divider is 0 and value isnt divider and pipsCount <= limit

module.exports = (elem, sourceKeypath) ->
	$elem = $ elem
	$parent = $elem.parent()
	$numbers = $parent.find '.numbers'
	$numberInput = $numbers.find 'input'
	inputKeypath = @getNodeKeypath $numberInput[0]

	wNumbOptions =
		decimals: 0

	pipsOptions =
		mode: 'steps'
		density: -1

	sliderOptions =
		animate: true
		start: 1
		step: 1
		range:
			min: 1
			max: 8
		format: wNumb wNumbOptions

	$elem.on 'change set', =>
		@updateModel()

	generatePipOptions = (value) ->
		update = {}
		if checkDivider value, 8
			update.filter = (pipValue, type) ->
				if pipValue % 8 is 0 or pipValue is sliderOptions.range.min then 2 else 0
		else if checkDivider value, 100
			update.filter = (pipValue, type) ->
				if pipValue % 100 is 0 or pipValue is sliderOptions.range.min then 2 else 0
		else if checkDivider value, 200
			update.filter = (pipValue, type) ->
				if pipValue % 200 is 0 or pipValue is sliderOptions.range.min then 2 else 0
		else
			update.filter = (pipValue, type) ->
				if pipValue is sliderOptions.range.min or pipValue is value then 1 else 2
		update

	observeKey = (keypath, rangeType) =>
		output = undefined
		dots = keypath.split '.'
		currentParam = dots.pop()
		currentKeypath = dots.join '.'
		currentKey = dots.pop()
		@observe currentKeypath, (newCurrent) ->
			return if _.isUndefined newCurrent
			source = @get('source') || configs
			return if _.isUndefined source
			current = source[currentKey][newCurrent]
			return if _.isUndefined current

			isInit = $elem.is '.noUi-target'
			newParam = parseInt current[currentParam]
			return if newParam is sliderOptions.range[rangeType]

			update =
				range: sliderOptions.range
			update.range[rangeType] = newParam
			update.start = newParam if rangeType is 'min' and not isInit

			_.assign sliderOptions, update

			output = newParam

			return unless isInit

			$elem.noUiSlider update, true
			$elem.noUiSlider_pips pipsOptions

		return output unless _.isUndefined output

	@observe sourceKeypath, (newSource, oldSource, keypath, idx) ->
		return if _.isUndefined newSource
		update = {}
		updatePips = {}
		funcsForKeys =
			min: (value) ->
				value = observeKey value, 'min' if _.isString value
				_.set update, 'range.min', value
				update.start = value if sliderOptions.start isnt value
			max: (value) ->
				value = observeKey value, 'max' if _.isString value
				_.set update, 'range.max', value
				_.assign pipsOptions, generatePipOptions value

				if value < parseInt $elem.val()
					update.start = value
			step: (value) ->
				update.step = value
			append: (value) ->
				# console.log value
				# update.format =


		_.forOwn newSource, (value, key) ->
			return unless _.has funcsForKeys, key
			funcsForKeys[key] value

		_.assign sliderOptions, update
		_.assign pipsOptions, updatePips unless _.isEmpty updatePips

		if oldSource
			$elem.noUiSlider update, true
		else
			$elem.noUiSlider sliderOptions
			$elem.Link('lower').to $numberInput

		$elem.noUiSlider_pips pipsOptions

	return teardown unless inputKeypath
	@observe inputKeypath, (value) ->
		value = parseInt value
		return if _.isNaN value
		sliderVal = parseInt $elem.val()
		return if value is sliderVal

		value = sliderOptions.range.max if value > sliderOptions.range.max
		value = sliderOptions.range.min if value < sliderOptions.range.min or _.isString value

		$elem.val value
		@set inputKeypath, value

	return teardown


/** WEBPACK FOOTER **
 ** ./assets/coffee/decorators/slider.coffee
 **/